import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <p>{`First install the core reforml library`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i reforml
`}</code></pre>
    <h2 {...{
      "id": "use-reforml-in-json-form"
    }}>{`Use Reforml in JSON Form`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {BaseForm} from 'reforml'  // simplest form element
import 'reforml/dist/index.css'   // default styling
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: text
    label: my first reforml field
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={setValue}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "use-reforml-with-yaml-string"
    }}>{`Use Reforml with YAML string`}</h2>
    <p>{`Just install some YAML parser such as `}<inlineCode parentName="p">{`js-yaml`}</inlineCode>{`. You can install that by`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i js-yaml
`}</code></pre>
    <p>{`and then`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`  import {BaseForm} from 'reforml'  // simplest form element
  import 'reforml/dist/index.css'   // default styling
  import jsyaml from 'js-yaml'      // yaml parser
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: text
    label: my second reforml field
    helperText: Use the react hook "useMemo" so it only parse the yaml once
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={setValue}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>
    <h2 {...{
      "id": "use-yaml-webpack-loader"
    }}>{`Use YAML Webpack loader`}</h2>
    <p>{`Install a yaml webpack loader, such as `}<inlineCode parentName="p">{`js-yaml-loader`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i -D js-yaml-loader
`}</code></pre>
    <p>{`In your webpack config,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// webpack.config.js
module: {
  rules: [{
    test: /\\.ya?ml$/,
    use: 'js-yaml-loader',
  }]
}
`}</code></pre>
    <p>{`Or if you are using Create React App that the webpack config is encapsulated, you can`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i -D react-app-rewired react-app-rewire-yaml
`}</code></pre>
    <p>{`then in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, change the `}<inlineCode parentName="p">{`"start": "react-script start"`}</inlineCode>{` to `}<inlineCode parentName="p">{`"start": "react-app-rewired start"`}</inlineCode>{`.`}</p>
    <p>{`At root create a new file `}<inlineCode parentName="p">{`config-overrides.js`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const rewireYAML = require('react-app-rewire-yaml');
module.exports = function override(config, env) {
  if (!config.plugins) {
    config.plugins = [];
  }
  config = rewireYAML(config, env)
  return config
}
`}</code></pre>
    <p>{`Then you can simply import the yaml file`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import fields from './my-fields.yaml'
`}</code></pre>
    <p>{`If you are using TypeScript you may need a declaration file `}<inlineCode parentName="p">{`./my-fields.yaml.d.ts`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Fields } from 'reforml'

declare module '**/*.reforml.yaml' {
  const fields: Fields
  export default fields
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      